import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export interface DraggableUniDriver extends BaseUniDriver {
  beginDrag: (details: { dataHook: string }) => Promise<void>;
  dragOver: (details: { dataHook: string }) => Promise<void>;
  endDrag: (details: { dataHook?: string }) => Promise<void>;
}
